import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import UserProfileMenu from './partials/UserProfileMenu';
import { defaultService } from '../../../../common/services';
import { confirmAlert } from 'react-confirm-alert';
import { userActions } from '../../../../common/redux/actions';

class UserProfilePhoto extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingProfile: false,
        };
    }

    handleUpload = (e) => {
        const { dispatch } = this.props;
        const imageType = e.target.files[0].type;
        if(imageType === 'image/jpeg' || imageType === 'image/jpg' || imageType === 'image/png' || imageType === 'image/gif') {
            this.setState({loadingProfile: true});
            defaultService.uploadWithoutProgress(e.target.files).then((res) => {
                let fileId = res.files[0].id;
                dispatch(userActions.profile("POST", {UserProfile: {avatar_id: fileId}}, 'avatar'));
                this.setState({loadingProfile: false});
            });
        } else {
            //alert('Please Select jpg, jpeg, png files');
            confirmAlert({
                //title: `Confirm Request`,
                message: 'Please Select jpg, jpeg, png, gif file',
                buttons: [
                    {
                        label: 'Ok',
                        onClick: () => console.log('clear')
                    }
                ]
            });
        }
    };

    
    render() {
        const { loadingProfile } = this.state;
        const { authentication } = this.props;
        const { user } = authentication.authentication;
        return (<DashboardLayout activeClass="UserSetting">
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Account Setting</h2>
                        </div>
                    </div>
                    <UserProfileMenu />
                    <div className="col-md-9">
                        <div className="post-box p-0">
                            <div className="heading">
                            Profile Photo
                            </div>
                            <div className="setting-form"> 
                                <div className="row">                                        
                                    <div className="col-md-4 col-lg-3 col-12">
                                        <div className="card-profile py-3">
                                            <figure className="d-flex align-items-center profile-upload justify-content-center">
                                                <div className="pic rounded-circle">
                                                    <img className="img-fluid rounded-circle border" alt="profile" width="145" height="145" src={(user && (user.avatar)) ? user.avatar : '/images/dummy-profile.png'} />
                                                    <label className="btn btn-primary btn-upload text-white rounded-circle">
                                                        <i class="fas fa-camera"></i>
                                                        <input type="file" accept="image/*" onChange={this.handleUpload} />
                                                    </label>
                                                    {loadingProfile && <div className="loader rounded-circle"><span></span> <span></span></div>}
                                                </div>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(UserProfilePhoto);